
import { defineComponent } from 'vue'
import settings from '@/config/default/setting.config'
import Logo from '@/assets/images/home/logo.png'
export default defineComponent({
  props: {
    collapse: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const title = settings.title
    return {
      title,
      Logo
    }
  }
})
